module.exports = __webpack_public_path__ + "static/media/new_shawarma.96ee8755.jpg";